<template>
    <!-- <div class="topbar-height z-index-fixed fixed top-0 left-0 w-full bg-a-egg-f5ebdc shadow-md py-2"> -->
    <div class="">
        <CookieBanner></CookieBanner>
        <div class="relative">
            <div class="topbar-height z-index-fixed absolute top-0 left-0 w-full bg-a-egg-f5ebdc shadow-md py-2">
                <div class="max-full-hd">
                    <div class="relative">
                        <img class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/5 logo-height" src="@/assets/header/logo-bk.svg" />
                        <div class="absolute top-2.5 right-5 flex items-center" v-if="showLangSwitchBtn">
                            <SwitchLanguageBtn></SwitchLanguageBtn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SwitchLanguageBtn from '@/components/Button/SwitchLanguageBtn.vue'
import CookieBanner from './UltimateTopBar/component/CookieBanner.vue'

export default {
    components: {
        SwitchLanguageBtn,
        CookieBanner,
    },
    props: {
        showLangSwitchBtn: { type: Boolean, default: true },
    },
}
</script>
<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    @import '@/style/base/display.scss';
    .topbar-height {
        height: $topbar-height;
    }
    .logo-height {
        height: $bk-logo-height;
    }
</style>
